import { render, staticRenderFns } from "./WhoIsAccountScore.vue?vue&type=template&id=43df4478&scoped=true"
import script from "./WhoIsAccountScore.vue?vue&type=script&lang=ts"
export * from "./WhoIsAccountScore.vue?vue&type=script&lang=ts"
import style0 from "./WhoIsAccountScore.vue?vue&type=style&index=0&id=43df4478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df4478",
  null
  
)

export default component.exports